import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SignatureTracker from '../components/SignatureTracker';
import SignaturePad from '../components/SignaturePad';
import html2pdf from 'html2pdf.js'; // Libreria para el PDF
import HptPdfTemplate from '../components/HptPdfTemplate'; // Componente invisible de Formato del PDF
import { useRef } from 'react';
import '../styles/HptScreens.css';
import Swal from 'sweetalert2';
import PermisoEscalera from '../components/PermisoEscalera';
import BloqueoElectrico from '../components/BloqueoElectrico';
import DescargoElectrico from '../components/DescargoElectrico';


// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// Tiempo HOY
const hoy = new Date().toISOString().split('T')[0];

// Map para apertura todos los deplegables
let mapDesplegable = {"Recursos Preventivos Asignados": 0, "Repuestos y Materiales": 0, "Recursos y Energías de Trabajo": 0, "Matriz de Riesgos y Medidas":0, "Personal Asignado y Habilitaciones":0};

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón unificado)
// ============================================================================
const ExpandableCard = ({ title, icon, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="expandable-card">
            <div className="card-header" onClick={() => {
                const newState = !isOpen;
                setIsOpen(newState);
                if (newState && onOpen){
                    onOpen(title)
                }
                
            }}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`card-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

// ============================================================================
// COMPONENTE PRINCIPAL: DetailsHPTScreen
// ============================================================================
const DetailsHPTScreen = () => {
    const { id } = useParams(); // ID de la HPT en la URL
    const navigate = useNavigate();
    
    // --- ESTADOS DE DATOS ---
    const [hpt, setHpt] = useState(null);               // Todos los datos de la planificación
    const [seguimiento, setSeguimiento] = useState([]); // Historial de quién ha firmado y quién falta
    const [showSignature, setShowSignature] = useState(false); // Modal de firma
    const [catalogo, setCatalogo] = useState([]);       // Catálogo de seguridad (Riesgos/Medidas)
    
    // Estado para ampliar las fotos subidas
    const [imagenAmpliada, setImagenAmpliada] = useState(null); 
    
    // Referencia al componente oculto del PDF
    const pdfRef = useRef();

    //Estado para comentarios de jefe de turno
    const [comentarioJT, setComentarioJT] = useState('');

    //R2
    const [archivosSubidos, setArchivosSubidos] = useState([]);

    //ESTADO PARA CONTROL DE LECTURA
    const [tarjetasLeidas, setTarjetasLeidas] = useState([]);
    const TOTAL_TARJETAS = 5;

    //Modal Escalera
    const [showEscaleraModal, setShowEscaleraModal] = useState(false); 
    const [datosEscaleraEditados, setDatosEscaleraEditados] = useState(null);

    // Control del Modal de Bloqueo Eléctrico
    const [showBloqueoModal, setShowBloqueoModal] = useState(false);
    const [bloqueoActivo, setBloqueoActivo] = useState(null);
    const [bloqueoIdx, setBloqueoIdx] = useState(null);

    // Control del Modal de Descargo Eléctrico
    const [showDescargoModal, setShowDescargoModal] = useState(false);
    const [descargoActivo, setDescargoActivo] = useState(null);
    const [descargoIdx, setDescargoIdx] = useState(null);

    // Estados de Edicion en Tiempo Real.
    const [trabajadoresEditados, setTrabajadoresEditados] = useState([]);
    const [descripcionEditada, setDescripcionEditada] = useState('');

    // ============================================================================
    // IDENTIFICACIÓN DEL USUARIO LOGUEADO
    // ============================================================================
    // Leemos el token JWT guardado al iniciar sesión para saber quién está usando la APP
    const token = localStorage.getItem('userToken');
    let currentUser = {};
    if (token) {
        try {
            // Decodificamos la parte central del JWT (atob) para leer el JSON sin hacer peticiones extra
            currentUser = JSON.parse(atob(token.split('.')[1]));
        } catch(e) {
            console.error("Error leyendo token");
        }
    }

    // Extraemos Rol, Grupo e ID para usarlos en las reglas de permisos
    const uRol = currentUser.rol;
    const uGrupo = currentUser.grupo;
    const uId = parseInt(currentUser.id);
    
    // ============================================================================
    // CARGA INICIAL DE DATOS
    // ============================================================================
    const fetchData = useCallback(async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        try {
            // Descargamos en paralelo: La HPT, el Tracker de Firmas y el Catálogo de Riesgos
            const [resHpt, resSeg, resCat, resArchivos] = await Promise.all([
                axios.get(`${API_URL}/api/hpt/${id}`, config),
                axios.get(`${API_URL}/api/hpt/${id}/seguimiento-firmas`, config),
                axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                axios.get(`${API_URL}/api/hpt/${id}/archivos`, config)
            ]);
            setHpt(resHpt.data);
            setSeguimiento(resSeg.data);
            setCatalogo(resCat.data.results || resCat.data);

            setArchivosSubidos(resArchivos.data || []);

            // Inicializacion de los Buffers de Edicion Local.
            setTrabajadoresEditados(resHpt.data.trabajadores || []);
            setDescripcionEditada(resHpt.data.descripcion_trabajo || '');

            //Si existe comentario de JT se carga
            if (resHpt.data.comentarios_jt) {
                setComentarioJT(resHpt.data.comentarios_jt);
            }
        } catch (err) { 
            console.error("Error al cargar detalles:", err); 
        }
    }, [id]);

    useEffect(() => { fetchData(); }, [fetchData]);
    
    // ============================================================================
    // LÓGICA DE PERMISOS FIRMAS:
    // ============================================================================
    // Esta función devuelve TRUE si el botón "Firmar" debe aparecer.
    const puedeFirmar = () => {
        if (!hpt || hpt.pendiente_de === "COMPLETO") return false;

        const paso = hpt.pendiente_de; //A quien le toca
        
        // Administrador APP siempre puede firmar... (Pruebas)
        if (uRol === 'ADMINISTRADOR') return true;  

        // Variables agrupadas
        const creadorEsMecanico = ['MECANICO','SPMecanico'].includes(hpt.creador_grupo);
        const creadorEsElectrico = ['ELECTRICOS', 'SPElectrico'].includes(hpt.creador_grupo);
        const creadorEsInstrumentacion = ['INSTRUMENTACION', 'SPInstrumentacion'].includes(hpt.creador_grupo);
        const creadorEsCampoSolar = ['CAMPO SOLAR', 'SPCampoSolar'].includes(hpt.creador_grupo);
        const creadorEsQuimico = ['QUIMICO', 'SPQuimico'].includes(hpt.creador_grupo);
        
        // Dependiendo del PASO de la firma tendrá permisos dependiendo del creador
        switch (paso) {
            case 'SOLICITANTE':
                // Si el creador es del mismo grupo
                if (hpt.creador_grupo === uGrupo) return true;
                // Si es creado en el Departamento de Operación puede firmar Oficial Operacion o Jefe Turno
                if (
                    ((hpt.creador_grupo === 'JEFE_TURNO') || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION') &&
                    (uGrupo === 'JEFE_TURNO' || (uRol === 'OFICIAL' && uGrupo === 'OPERACION'))
                ) return true;
                
                // Si es creador en el Deparmento de Mantenimiento puede firmar Oficiales de Su grupo o Responsables directos.
                if (
                    (creadorEsElectrico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                    ((uRol === 'OFICIAL' && (uGrupo === 'ELECTRICOS')) || (uRol === 'SUPERVISOR' && uGrupo === 'SPElectrico'))
                ) return true;

                if (
                    (creadorEsElectrico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                    ((uRol === 'OFICIAL' && (uGrupo === 'MECANICO')) || (uRol === 'SUPERVISOR' && uGrupo === 'SPMecanico'))
                ) return true;

                if (
                    (creadorEsInstrumentacion || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                    ((uRol === 'OFICIAL' && (uGrupo === 'INSTRUMENTACION')) || (uRol === 'SUPERVISOR' && uGrupo === 'SPInstrumentacion'))
                ) return true;

                if (
                    (creadorEsCampoSolar || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                    ((uRol === 'OFICIAL' && (uGrupo === 'CAMPO SOLAR')) || (uRol === 'SUPERVISOR' && uGrupo === 'SPCampoSolar'))
                ) return true;

                if (
                    (creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento')) && 
                    ((uRol === 'OFICIAL' && (uGrupo === 'QUIMICO')) || (uRol === 'SUPERVISOR' && uGrupo === 'SPQuimico'))
                ) return true;

                return false;

            case 'RESP_SUBCONTRATA':
                // Si la persona logueada es el RESP_SUBCONTRATA INDICADO
                if (hpt.id_usuario_subcontrata && uId === hpt.id_usuario_subcontrata) return true;
                // Jefe TURNO u Oficial Operacion puede firmar, si la crea alguien de operacioón
                if (
                    (uRol === 'JEFE_TURNO' || (uRol === 'OFICIAL' && uGrupo === 'OPERACION')) && 
                    (hpt.creador_rol === 'JEFE_TURNO' || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                ) return true;
                // Si es un oficial, puede firmar si pertence a su grupo o si la creo el supervisor de su grupo o la creo el Responsable de Mantenimiento.
                if (uRol === 'OFICIAL' && 
                    (
                        uGrupo === hpt.creador_grupo || 
                        (hpt.creador_grupo === 'SPMecanico' && uGrupo === 'MECANICO') || 
                        (hpt.creador_grupo === 'SPCampoSolar' && uGrupo === 'CAMPO SOLAR') ||
                        (hpt.creador_grupo === 'SPElectrico' && uGrupo === 'ELECTRICOS') ||
                        (hpt.creador_grupo === 'SPInstrumentacion' && uGrupo === 'INSTRUMENTACION') ||
                        (hpt.creador_grupo === 'SPQuimico' && uGrupo === 'QUIMICO')
                    )
                ) return true; 
                return false;

            case 'PREVENCION':
                // Solo Prevencion o Responsables de Operacion o Mantenimiento pueden firmar este apartado
                if (uRol === 'PREVENCION' || uRol === 'GESTOR') return true;
                return false;

            case 'SUPERVISOR':

                if (
                    (uRol === 'GESTOR' && uGrupo === 'Mantenimiento') && // Usuario Gestor Mantenimiento
                    (creadorEsMecanico || creadorEsElectrico || creadorEsInstrumentacion || creadorEsCampoSolar || creadorEsQuimico || hpt.creador_rol === "SUPERVISOR" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento'))
                ) return true;

                if(
                    (uRol === 'GESTOR' && uGrupo === 'Operacion') &&  // Usuario Gestor Operacion
                    (hpt.creador_rol === "JEFE_TURNO" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                ) return true;
                
                if (uRol === 'SUPERVISOR') { //Usuario Supervisor
                    if (creadorEsMecanico || creadorEsElectrico || creadorEsInstrumentacion || creadorEsCampoSolar || creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') ||  hpt.creador_rol === 'SUPERVISOR') return true;
                }
                return false;

            case 'JEFE_TURNO':
                // Última firma: Exclusiva del Jefe de Turno o responsable de Operación
                return uRol === 'JEFE_TURNO' || (uRol === 'GESTOR' && uGrupo === 'Operacion');

            default:
                return false;
        }
    };

    // ============================================================================
    // ACCIONES DE GUARDADO PARCIAL DIRECTO DESDE DETALLES
    // ============================================================================
    
    // Funciones helper locales para mutar el array de subcontratas de forma reactiva
    const addTrabajadorEnDetalle = () => {
        setTrabajadoresEditados([...trabajadoresEditados, {
            nombre: '', apellidos: '', empresa: '', 
            carretilla_elevadora: false, carretilla_telescopica: false,
            plataforma_elevadora: false, puente_grua: false,
            espacios_confinados: false, baja_tension: false,
            alta_tension: false, recurso_preventivo: false,
            camion_pluma: false, grua: false,
            formacion_altura: false, otros: ''
        }]);
    };

    const updateTrabajadorEnDetalle = (idx, field, val) => {
        const newT = [...trabajadoresEditados];
        newT[idx][field] = val;
        setTrabajadoresEditados(newT);
    };

    // Guardado de subcontratas añadidas en el transcurso de cualquier firma activa
    const handleGuardarTrabajadores = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const payload = {
            id_planta: hpt.id_planta,
            titulo: hpt.titulo,
            ot_referencia: hpt.ot_referencia,
            id_activo: hpt.id_activo,
            den_act_descripcion: hpt.den_act_descripcion,
            descripcion_trabajo: hpt.descripcion_trabajo,
            operarios_previstos: hpt.operarios_previstos,
            duracion_prevista_hours: hpt.duracion_prevista_hours,
            fecha_prevista: hpt.fecha_prevista,
            horario_previsto: hpt.horario_previsto,
            dias_previstos: hpt.dias_previstos,
            id_localizacion: hpt.id_localizacion,
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
            id_usuario_subcontrata: hpt.id_usuario_subcontrata,
            tipo_incidencia: hpt.tipo_incidencia,
            id_st: hpt.id_st,
            riesgos_seleccionados: hpt.riesgos_detallados.map(r => ({ id_item_seguridad: r.id_item, observacion_riesgo: r.observacion_riesgo })),
            materiales: hpt.materiales,
            recursos: hpt.recursos,
            trabajadores: trabajadoresEditados, // Inyectamos Buffer Editado
            preventivos: hpt.preventivos_detallados.map(p => p.nombre_recurso_preventivo),
            imagenes: hpt.imagenes,
            anexo_escalera: hpt.anexo_escalera 
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}`, payload, config);
            Swal.fire('¡Personal Guardado!', 'El listado de trabajadores ha sido actualizado con éxito.', 'success');
            fetchData();
        } catch (error) {
            console.error("Error guardando trabajadores:", error);
            Swal.fire('Error', 'No se pudo guardar la modificación de personal.', 'error');
        }
    };

    // Guardado de nueva descripción restringida exclusivamente al paso del Supervisor
    const handleGuardarDescripcion = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        const payload = {
            id_planta: hpt.id_planta,
            titulo: hpt.titulo,
            ot_referencia: hpt.ot_referencia,
            id_activo: hpt.id_activo,
            den_act_descripcion: hpt.den_act_descripcion,
            descripcion_trabajo: descripcionEditada, // Inyectamos Nueva Descripcion
            operarios_previstos: hpt.operarios_previstos,
            duracion_prevista_hours: hpt.duracion_prevista_hours,
            fecha_prevista: hpt.fecha_prevista,
            horario_previsto: hpt.horario_previsto,
            dias_previstos: hpt.dias_previstos,
            id_localizacion: hpt.id_localizacion,
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
            id_usuario_subcontrata: hpt.id_usuario_subcontrata,
            tipo_incidencia: hpt.tipo_incidencia,
            id_st: hpt.id_st,
            riesgos_seleccionados: hpt.riesgos_detallados.map(r => ({ id_item_seguridad: r.id_item, observacion_riesgo: r.observacion_riesgo })),
            materiales: hpt.materiales,
            recursos: hpt.recursos,
            trabajadores: hpt.trabajadores,
            preventivos: hpt.preventivos_detallados.map(p => p.nombre_recurso_preventivo),
            imagenes: hpt.imagenes,
            anexo_escalera: hpt.anexo_escalera 
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}`, payload, config);
            Swal.fire('¡Alcance Modificado!', 'La descripción del trabajo ha sido actualizada correctamente.', 'success');
            fetchData();
        } catch (error) {
            console.error("Error guardando descripción:", error);
            Swal.fire('Error', 'No se pudo actualizar la descripción de las tareas.', 'error');
        }
    };

    // ============================================================================
    // ACCIONES DE FIRMA Y RECHAZO
    // ============================================================================
    const handleSign = async (signatureBase64) => {

        setShowSignature(false);

        const token = localStorage.getItem('userToken');
        let ptw_id_elegido = null;
        const paso = hpt.pendiente_de;

        if(paso === 'JEFE_TURNO'){
            try {
                const plantaDocumento = hpt.id_planta;
                // Pedimos el número sugerido al backend
                const res = await axios.get(`${API_URL}/api/ptw/siguiente-numero?planta=${plantaDocumento}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const numeroSugerido = res.data.siguiente_numero;
                
                // Lanzamos el Modal para que edite o confirme
                const { value: numeroFinal, isConfirmed } = await Swal.fire({
                    title: 'Creación de Permiso de Trabajo',
                    text: 'Revisa y confirma el número de PTW:',
                    input: 'text',
                    inputValue: numeroSugerido,
                    showCancelButton: true,
                    confirmButtonColor: '#003366',
                    confirmButtonText: 'Firmar y Crear',
                    cancelButtonText: 'Cancelar'
                });

                // Si le da a cancelar o lo deja vacío, cortamos la función y NO enviamos la firma
                if (!isConfirmed || !numeroFinal) {
                    setShowSignature(false); //Cierre el pad de firmas sin cancelar
                    return; 
                }

                // Guardamos el número definitivo que se ha elegido
                ptw_id_elegido = numeroFinal;

            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo contactar con el servidor para obtener el número correlativo.',
                    icon: 'error',
                    confirmButtonColor: '#003366'
                });
                return;
            }
        }
        try {
            await axios.post(`${API_URL}/api/hpt/${id}/firmar`, {
                firma_path: signatureBase64,
                es_sustituto: false, // Funcionalidad futura
                ptw_id_elegido: ptw_id_elegido // Si no es JT, viajará como null y el backend lo ignora
            }, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            Swal.fire({
                title: "¡Correcto!",
                text: paso === 'JEFE_TURNO' ? "HPT validada y PTW creado con éxito." : "Firma registrada correctamente.",
                icon: "success",
                confirmButtonColor: '#003366',
                timer: 2000
            });

            fetchData(); // Recargamos para que salte al siguiente paso
        } catch (err) {
            if (err.response?.data?.error === 'ID_PTW_DUPLICADO') {
                Swal.fire({
                    title: "Número en uso",
                    text: err.response.data.detail,
                    icon: "warning",
                    confirmButtonColor: '#003366'
                });
            } else {
                Swal.fire({
                    title: "Error al firmar",
                    text: err.response?.data?.detail || "Hubo un problema al procesar la firma.",
                    icon: "error",
                    confirmButtonColor: '#003366'
                });
            }
        }
    };

    const handleRechazar = async () => {
        const { value: motivo } = await Swal.fire({
            title: 'Rechazar Planificación',
            input: 'textarea',
            inputLabel: 'Indique el motivo del rechazo:',
            inputPlaceholder: 'Escribe aquí el motivo...',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#999',
            confirmButtonText: 'Sí, rechazar',
            cancelButtonText: 'Cancelar'
        });
        if (!motivo) return; // Si cancela, no hace nada

        const token = localStorage.getItem('userToken');
        try {
            await axios.post(`${API_URL}/api/hpt/${id}/rechazar`, {motivo}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            Swal.fire({
                title: "Planificación rechazada.",
                text: "La planificación ha sido rechazada correctamente.",
                icon: "success",
                confirmButtonColor: '#003366'
            })
            fetchData(); // Recargamos, el estado cambia y se muestra banner rojo del rechazo
        } catch (err) { 
            Swal.fire({
                title: "Error al rechazar",
                text: "Error al rechazar",
                icon: "error",
                confirmButtonColor: '#003366'
            })
        }
    };

    const handleGuardarComentarioJT = async () => {
        const token = localStorage.getItem('userToken');
        try {
            await axios.put(`${API_URL}/api/hpt/${id}/comentario-jt`, { 
                comentarios_jt: comentarioJT 
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            Swal.fire({
                title: "Comentario guardado correctamente",
                text: "Comentario guardado correctamente en la planificación",
                icon: "success",
                confirmButtonColor: '#003366'
            })
            fetchData(); // Recargamos los datos
        } catch (err) { 
            Swal.fire({
                title: "Error al guardar el comentario",
                text: "Error al guardar el comentario",
                icon: "error",
                confirmButtonColor: '#003366'
            })
        }
    };

    // ============================================================================
    // Comprobacion de Titulo de Tarjeta abierta
    // ============================================================================
    const handleMarcarLeida = (tituloTarjeta) => {
        setTarjetasLeidas(prev => {
            if (!prev.includes(tituloTarjeta)) return [...prev, tituloTarjeta];
            return prev;
        });
    };

    const haLeidoTodo = tarjetasLeidas.length === TOTAL_TARJETAS;

    // ============================================================================
    // EXPORTACIÓN A PDF
    // ============================================================================
    // Convierte el componente <HptPdfTemplate> oculto en un archivo PDF usando html2pdf
    const handleDownloadPDF = () => {
        const element = pdfRef.current;
        const opt = {
            margin:       [10, 5, 10, 5],
            filename:     `HPT_${hpt.numero_ptw}.pdf`,
            image:        { type: 'jpeg', quality: 0.8 },
            html2canvas:  { scale: 2, useCORS: true },
            jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
            pagebreak:    { mode: ['css', 'legacy'] }
        };
        html2pdf().set(opt).from(element).save();
    };

    // ============================================================================
    // GESTIÓN DE DOCUMENTOS (DESCARGA)
    // ============================================================================
    const handleDescargarArchivo = async (idArchivo, nombre, tipo) => {
        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/hpt/archivo/${idArchivo}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob' // Indicamos que es binario
            });

            // Forzar descarga al PC/Móvil
            const url = window.URL.createObjectURL(new Blob([res.data], { type: tipo }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            Swal.fire('Error', 'No se pudo descargar el archivo.', 'error');
        }
    };

    // ============================================================================
    // PERMISOS DE EDICIÓN
    // ============================================================================
    // Verifica si el usuario actual tiene permisos para modificar la HPT
    const tienePermisoEdicion = () => {
        if (!hpt) return false;
        
        const cId = hpt.id_usuario_creador;
        const cRol = hpt.creador_rol;
        const cGrupo = hpt.creador_grupo;

        // El creador o un admin siempre pueden editar siempre
        if (uRol === 'ADMINISTRADOR' || uId === cId) return true;

        // Lógica de escalado jerárquico para la edición
        switch (cRol) {
            //Si el creador es Jefe turno, pueden modificar los Jefe de Turno y el responsable de Operación
            case 'JEFE_TURNO':
                if (uRol === 'JEFE_TURNO' || (uRol === 'GESTOR' && uGrupo === 'Operacion')) return true;
                return false;
            // Si el creador es un gestor, solo podrá modificarlo el.
            case 'GESTOR':
                return false; 
            // Si el creador es un supervisor, podrán modificarlo el supervisor o su homónimo o el responsable superior.
            case 'SUPERVISOR':
                if ((uRol === 'SUPERVISOR') || (uRol === 'GESTOR' && uGrupo === 'Mantenimiento')) return true;
                return false;
            // Si el creador es prevencion solo podra él.
            case 'PREVENCION':
                return false;
            case 'OFICIAL':
                if (uRol === 'OFICIAL' && uGrupo === cGrupo) return true;
                if (uRol === 'GESTOR' && uGrupo === 'Mantenimiento' && cGrupo != 'OPERACION') return true;
                if (uRol === 'SUPERVISOR' && cGrupo != 'OPERACION') return true;
                if (cGrupo === 'OPERACION' && ((uRol === 'GESTOR' && uGrupo === 'Operacion') || uRol === 'JEFE_TURNO')) return true;
                return false;
            default:
                return false;
        }
    };

    // Si no tiene firmas, se puede editar segun jerarquía. Si firma Solicitante solo puede modificar él. SI tiene más firmas no se puede modificar a no ser que se rechace.
    const puedeEditarVoluntariamente = () => {
        if (!hpt) return false;

        // Filtro de firmas reales creadas
        const firmasRealizadas = seguimiento.filter(paso => paso.firmado);
        const numFirmas = firmasRealizadas.length;

        // Comprobamos Rechazo
        const estaRechazada = hpt.comentarios_rechazo !== null;

        // Rama 1: Rechazada o sin firmas (borrador)
        if (numFirmas === 0 || estaRechazada) {
            return tienePermisoEdicion();
        }

        // Rama 2: Ya tiene Firma solicitante. Solo puede modificar este.
        if (numFirmas === 1 && !estaRechazada) {
            const firmaSolicitante = firmasRealizadas[0]; // Cogemos esa única firma
            
            // Si el ID coincide aparece botón
            return firmaSolicitante.id_firmante === uId;
        }

        // Más de una firma, no se puede modificar.
        return false;
    };

    // Si ha sido rechazada, el botón de editar siempre debe salir para poder corregirla
    const puedeCorregirRechazo = () => {
        if (!hpt) return false;
        return tienePermisoEdicion() && hpt.comentarios_rechazo !== null;
    };

    const puedeEditarEscalera = () => {
        return puedeEditarVoluntariamente() || puedeCorregirRechazo();
    };

    // ============================================================================
    // ACCIONES DE FOTOGRAFÍAS
    // ============================================================================
    // Crea un link invisible en el navegador, le asigna la imagen en Base64 y simula un clic para descargarla
    const descargarImagen = (base64, index) => {
        const link = document.createElement('a');
        link.href = base64;
        link.download = `HPT_${id}_foto_${index + 1}.jpg`; // Nombre del archivo descargado
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // ============================================================================
    // ACTUALIZACIÓN DE ANEXO ESCALERA
    // ============================================================================
    const handleActualizarEscalera = async (datosNuevosEscalera) => {
        const token = localStorage.getItem('userToken');
        
        // Formatemos arrays para formato de check
        const anexoFormateado = {
            ...datosNuevosEscalera,
            clasificacion: Array.isArray(datosNuevosEscalera.clasificacion) ? datosNuevosEscalera.clasificacion.join(', ') : (datosNuevosEscalera.clasificacion || ''),
            justificacion: Array.isArray(datosNuevosEscalera.justificacion) ? datosNuevosEscalera.justificacion.join(', ') : (datosNuevosEscalera.justificacion || ''),
            medioAutorizacion: datosNuevosEscalera.medioAutorizacion || ""
        };

        // Construimos el Payload reconstruyendo la HPT tal cual está, pero pisando el anexo
        const payload = {
            id_planta: hpt.id_planta,
            titulo: hpt.titulo,
            ot_referencia: hpt.ot_referencia,
            id_activo: hpt.id_activo,
            den_act_descripcion: hpt.den_act_descripcion,
            descripcion_trabajo: hpt.descripcion_trabajo,
            operarios_previstos: hpt.operarios_previstos,
            duracion_prevista_hours: hpt.duracion_prevista_hours,
            fecha_prevista: hpt.fecha_prevista,
            horario_previsto: hpt.horario_previsto,
            dias_previstos: hpt.dias_previstos,
            id_localizacion: hpt.id_localizacion,
            interviene_subcontrata: hpt.interviene_subcontrata === 1,
            id_usuario_subcontrata: hpt.id_usuario_subcontrata,
            tipo_incidencia: hpt.tipo_incidencia,
            id_st: hpt.id_st,
            
            // Reconstrucción de arrays para que Zod no se queje
            riesgos_seleccionados: hpt.riesgos_detallados.map(r => ({ id_item_seguridad: r.id_item, observacion_riesgo: r.observacion_riesgo })),
            materiales: hpt.materiales,
            recursos: hpt.recursos,
            trabajadores: hpt.trabajadores,
            preventivos: hpt.preventivos_detallados.map(p => p.nombre_recurso_preventivo),
            imagenes: hpt.imagenes,
            
            // Inyectamos anexo
            anexo_escalera: anexoFormateado 
        };

        try {
            await axios.put(`${API_URL}/api/hpt/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            Swal.fire('Guardado', 'El Permiso de Escalera se ha actualizado correctamente.', 'success');
            setShowEscaleraModal(false);
            fetchData(); // Recargamos para ver los cambios
        } catch (error) {
            console.error("Error actualizando escalera", error);
            Swal.fire('Error', 'No se pudo actualizar el permiso de escalera.', 'error');
        }
    };

    if (!hpt) return <div style={{padding: '50px'}}>Cargando planificación...</div>;


    // ============================================================================
    //  Guardar Candados desde Modal
    // ============================================================================

    // Bloqueos
    const handleGuardarCandadoBloqueo = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const bloqueosActualizados = hpt.bloqueos_electricos.map((b, idx) => 
            idx === bloqueoIdx ? { ...b, num_candado: nuevoNumeroCandado } : b
        );

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/descargos`, {
                bloqueos_electricos: bloqueosActualizados,
                descargos_electricos: hpt.descargos_electricos || [],
                descargos_mecanicos: hpt.descargos_mecanicos || []
            }, config);

            Swal.fire('Candado Registrado', 'El candado se ha guardado en el Bloqueo.', 'success');
            setShowBloqueoModal(false);
            fetchData(); 
        } catch (error) {
            console.error("Error al guardar bloqueo:", error);
            Swal.fire('Error', 'No se pudo actualizar el candado.', 'error');
        }
    };

    // Descargos
    const handleGuardarCandadoDescargo = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const descargosActualizados = hpt.descargos_electricos.map((d, idx) => 
            idx === descargoIdx ? { ...d, num_candado: nuevoNumeroCandado } : d
        );

        try {
            await axios.put(`${API_URL}/api/hpt/${id}/descargos`, {
                bloqueos_electricos: hpt.bloqueos_electricos || [],
                descargos_electricos: descargosActualizados,
                descargos_mecanicos: hpt.descargos_mecanicos || []
            }, config);

            Swal.fire('Candado Registrado', 'El candado se ha guardado en el Descargo.', 'success');
            setShowDescargoModal(false);
            fetchData(); 
        } catch (error) {
            console.error("Error al guardar descargo:", error);
            Swal.fire('Error', 'No se pudo actualizar el candado.', 'error');
        }
    };

    // ============================================================================
    //  RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            {/* --- Plantilla Oculta para el PDF --- */}
            {/* Este div no se ve en pantalla, pero existe en el HTML para que html2pdf pueda leerlo y convertirlo a PDF */}
            <div style={{ display: 'none' }}>
                <HptPdfTemplate ref={pdfRef} hpt={hpt} seguimiento={seguimiento} catalogo={catalogo} />
            </div>

            {/* --- 1. ENCABEZADO ESTILO PROFESIONAL --- */}
            <div className="top-header">
                <div className="d-flex align-center">
                    <span className="ptw-label">PLANIFICACIÓN:</span>
                    <div className="ptw-badge">
                        <span style={{ fontSize: '20px' }}>📋</span> 
                        OT: {hpt.ot_referencia}
                    </div>
                </div>
                
                <div className="header-actions">
                    <button onClick={handleDownloadPDF} className="btn-print">🖨️ Generar PDF Oficial</button>
                    {/* El botón de modificar solo sale si se cumplen las condiciones de arriba */}
                    {(puedeEditarVoluntariamente() || puedeCorregirRechazo()) && (
                        <button className="btn-modify" onClick={() => navigate(`/editar-hpt/${hpt.id_hpt}`)}>
                            ⚙️ Modificar Planificación
                        </button>
                    )}
                    <button onClick={() => navigate('/dashboard')} className="btn-close">Volver</button>
                    <button className="btn-volverDash" onClick={() => navigate('/planificador')}>🪛 Ir a Planificador</button>
                </div>
            </div>

            {/* --- INDICADOR DE ESTADO (Banner Verde o Naranja) --- */}
            <div className="d-flex align-center mb-20">
                <span className="ptw-label">ESTADO ACTUAL:</span>
                <div className={`status-badge-main ${hpt.pendiente_de === 'COMPLETO' ? 'status-complete' : 'status-pending'}`}>
                    <span>{(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy) ? '✍️' : '⏳'}</span>
                    {(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy) ? 'PLANIFICACIÓN COMPLETADA' : `ESPERANDO A: ${hpt.pendiente_de}`}
                </div>
            </div>

            {/* --- BANNER DE RECHAZO (Aparece solo si alguien le dio a Rechazar) --- */}
            {hpt.comentarios_rechazo && (
                <div className="reject-banner">
                    <span style={{fontSize: '24px'}}>⚠️</span>
                    <div className="flex-1"> 
                        <strong>ESTA PLANIFICACIÓN FUE RECHAZADA</strong>
                        <p style={{margin: '5px 0', fontSize: '14px'}}>{hpt.comentarios_rechazo}</p>
                    </div>
                    {tienePermisoEdicion() && (
                        <button className="btn-action-reject" onClick={() => navigate(`/editar-hpt/${hpt.id_hpt}`)}>✏️ Corregir Planificación</button>
                    )}
                </div>
            )}

            {/* --- LAYOUT PRINCIPAL*/}
            {/* En web es un Grid (60% izq, 40% der). En el móvil se apilan */}
            <div className="main-layout-details">
                
                {/* === COLUMNA IZQUIERDA: DATOS DE LA HPT === */}
                <div className="left-column">
                    
                    {/* TARJETA PRINCIPAL: DATOS DEL TRABAJO */}
                    <div className="main-card">
                        <div className="card-header-internal">Información General del Trabajo</div>
                        
                        {/* SECCIÓN DEL ACTIVO */}
                        <div className="asset-section-hpt">
                            <div className="asset-row-flex">
                                <div className="icon-circle-small">⚙️</div>
                                <div className="d-flex" style={{ flexDirection: 'column' }}>
                                    <span className="info-value title-display-text">
                                        {hpt.titulo || 'Sin título'}
                                    </span>
                                    <span className="asset-code-text">
                                        ACTIVO: {hpt.codigo_activo || 'S/A'}
                                    </span>
                                    <span className="asset-name-text">
                                        {hpt.den_act_descripcion}
                                    </span>
                                    <span className="asset-loc-tag">
                                        📍 Ubicación: {hpt.nombre_zona || 'Planta General'}
                                    </span>
                                    <span className="asset-loc-tag">
                                        🔧 TIPO INCIDENCIA: {hpt.tipo_incidencia || ''}
                                    </span>
                                    <span className="asset-loc-tag">
                                        📄 NÚMERO PTs: {hpt.numero_ptw || 'Pendiente'}
                                    </span>
                                    {hpt.id_st && (
                                        <span className="asset-loc-tag">
                                            🎫 NÚMERO ST: {hpt.id_st || ''}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* GRID DE DATOS TÉCNICOS */}
                        <div className="info-grid">
                            <div className="info-box">
                                <span className="info-label">👥 OPERARIOS:</span>
                                <span className="info-value">{hpt.operarios_previstos}</span>
                            </div>
                            <div className="info-box">
                                <span className="info-label">📅 FECHA PREVISTA:</span>
                                <span className="info-value">{hpt.fecha_prevista}</span>
                            </div>
                            <div className="info-box">
                                <span className="info-label">🕒 HORARIO:</span>
                                <span className="info-value">{hpt.horario_previsto}</span>
                            </div>
                            <div className="info-box">
                                <span className="info-label">⏳ DURACIÓN:</span>
                                <span className="info-value">{hpt.duracion_prevista_hours} Horas</span>
                            </div>
                            <div className="info-box">
                                <span className="info-label">📅 DURACIÓN DÍAS:</span>
                                <span className="info-value">
                                    {hpt.dias_previstos} {hpt.dias_previstos === 1 ? 'Día' : 'Días'} ({hpt.duracion_prevista_hours/hpt.dias_previstos}h/día)
                                </span>
                            </div>
                        </div>

                        {/* DESCRIPCIÓN MUTABLE SOLO DURANTE EL PASO DEL SUPERVISOR */}
                        <div className="description-container">
                            <span className="info-label">DESCRIPCIÓN DE LAS TAREAS:</span>
                            {hpt.pendiente_de === 'SUPERVISOR' && puedeFirmar() ? (
                                <div className="desc-edit-container">
                                    <textarea 
                                        rows="4" 
                                        className="main-textarea" 
                                        value={descripcionEditada} 
                                        onChange={e => setDescripcionEditada(e.target.value)} 
                                    />
                                    <button 
                                        type="button" 
                                        className="btn-save btn-save-desc" 
                                        onClick={handleGuardarDescripcion}
                                    >
                                        💾 Guardar Nueva Descripción
                                    </button>
                                </div>
                            ) : (
                                <div className="desc-text-details">{hpt.descripcion_trabajo}</div>
                            )}
                        </div>
                    </div>

                    {/* SECCIÓN DE IMÁGENES. Solo si tenemos imagenes subidas */}
                    {hpt.imagenes && hpt.imagenes.length > 0 && (
                        <div className="mt-20">
                            <h3 style={{ color: '#1a237e', borderBottom: '2px solid #eee', paddingBottom: '5px' }}>
                                📸 Fotografías Adjuntas
                            </h3>
                            <div className="photo-preview-container">
                                {hpt.imagenes.map((imgBase64, index) => (
                                    <div key={index} className="photo-gallery-item">
                                        <img 
                                            src={imgBase64} 
                                            alt={`Adjunto ${index + 1}`} 
                                            onClick={() => setImagenAmpliada({ src: imgBase64, index })}
                                            className="photo-gallery-img"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* --- Para ver la imagen en grande y descargarla --- */}
                    {imagenAmpliada && (
                        // El onClick en el overlay cierra modal si pincha fuera
                        <div className="modal-overlay" onClick={() => setImagenAmpliada(null)}>
                            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                <button className="close-btn" onClick={() => setImagenAmpliada(null)}>✖</button>
                                
                                <img 
                                    src={imagenAmpliada.src} 
                                    alt="Ampliación" 
                                    className="modal-image" 
                                />
                                
                                <button 
                                    className="download-btn" 
                                    onClick={() => descargarImagen(imagenAmpliada.src, imagenAmpliada.index)}
                                >
                                    ⬇️ Descargar Imagen
                                </button>
                            </div>
                        </div>
                    )}

                    {/* SECCIÓN DE DOCUMENTOS ADJUNTOS (Solo Lectura) */}
                    {archivosSubidos.length > 0 && (
                        <div className="document-section">
                            <h3 className="section-title">📎 Documentos Adjuntos y Descargos</h3>
                            <div className="document-list">
                                {archivosSubidos.map(archivo => (
                                    <div key={archivo.id_archivo} className="document-item">
                                        <div className="document-info">
                                            <span className="document-icon">📄</span>
                                            <span>
                                                {archivo.nombre_archivo} <br/>
                                                <small className="text-muted-small">Subido el: {new Date(archivo.fecha_subida).toLocaleDateString()}</small>
                                            </span>
                                        </div>
                                        <div className="document-actions">
                                            <button 
                                                type="button" 
                                                onClick={() => handleDescargarArchivo(archivo.id_archivo, archivo.nombre_archivo, archivo.tipo_archivo)} 
                                                className="btn-download-file"
                                            >
                                                ⬇️ Descargar
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* --- BLOQUES DESPLEGABLES (Acordeones Técnicos) --- */}
                    
                    {/* 1. Recurso Preventivo */}
                    <ExpandableCard onOpen={handleMarcarLeida}  title="Recursos Preventivos Asignados" icon="🛡️">
                        <ul className="simple-list">
                            {hpt.preventivos_detallados?.map((p, i) => (
                                <li key={i} className="simple-list-item">👤 {p.nombre_recurso_preventivo}</li>
                            ))}
                        </ul>
                    </ExpandableCard>

                    {/* 2. Materiales */}
                    <ExpandableCard onOpen={handleMarcarLeida}  title="Repuestos y Materiales" icon="🔧">
                        <table className="table">
                            <thead>
                                <tr className="table-header-row">
                                    <th>Descripción</th>
                                    <th>UD</th>
                                    <th>Almacén</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hpt.materiales?.map((m, i) => (
                                    <tr key={i} className="table-item-row">
                                        <td className="td">{m.descripcion}</td>
                                        <td className="td">{m.unidades}</td>
                                        <td className="td">{m.almacen}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </ExpandableCard>

                    {/* 3. Recursos y Energías */}
                    <ExpandableCard onOpen={handleMarcarLeida} title="Recursos y Energías de Trabajo" icon="⚡">
                        <div className="resource-grid">
                            {['EQUIPO ESPECIAL', 'ACCESO', 'ENERGÍA TRABAJO', 'ENERGÍA EQUIPO', 'TRABAJOS PREVIOS'].map(cat => (
                                <div key={cat} className="res-col">
                                    <div className="res-cat-title">{cat}</div>
                                    {hpt.recursos?.filter(r => r.categoria === cat && r.valor_check).map(r => (
                                        <div key={r.nombre_recurso} className="res-item">
                                            <div>✅ {r.nombre_recurso}
                                                {r.nombre_recurso === 'Químicos' && r.detalle_texto && (
                                                    <span className="res-text-detail"> ({r.detalle_texto})</span>
                                                )}
                                            </div>
                                            
                                            {/*Si es Escalera y tenemos datos del anexo en la BD, aparecerá el boton*/}
                                            {r.nombre_recurso === 'Escalera' && hpt.anexo_escalera && (
                                                <button 
                                                    onClick={() => {
                                                        setDatosEscaleraEditados(hpt.anexo_escalera);
                                                        setShowEscaleraModal(true);
                                                    }} 
                                                    className="btn-view-ladder" 
                                                >
                                                    🪜 Ver Solicitud Escalera
                                                </button>
                                            )}

                                            {/* 🔒 Miniaturas predictivas para Bloqueos Eléctricos */}
                                            {r.nombre_recurso === 'Enclavamiento eléctrico' && hpt.bloqueos_electricos?.length > 0 && (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px', paddingLeft: '15px' }}>
                                                    {hpt.bloqueos_electricos.map((b, bIdx) => (
                                                        <span 
                                                            key={bIdx} 
                                                            className="skill-tag" 
                                                            style={{ backgroundColor: '#90caf9', color: '#2e7d32', border: '1px solid #90caf9', cursor: 'pointer', padding: '3px 6px' }}
                                                            onClick={() => {
                                                                setBloqueoActivo(b);
                                                                setBloqueoIdx(bIdx);
                                                                setShowBloqueoModal(true);
                                                            }}
                                                        >
                                                            🔒 {b.activo} {b.num_candado ? `(Candado: ${b.num_candado})` : '⚠️ Sin Candado'}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}

                                            {/* ⚡ Miniaturas predictivas para Descargos Eléctricos */}
                                            {r.nombre_recurso === 'Descargo eléctrico' && hpt.descargos_electricos?.length > 0 && (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px', paddingLeft: '15px' }}>
                                                    {hpt.descargos_electricos.map((d, dIdx) => (
                                                        <span 
                                                            key={dIdx} 
                                                            className="skill-tag" 
                                                            style={{ backgroundColor: '#ffe0b2', color: '#2e7d32', border: '1px solid #ffe0b2', cursor: 'pointer', padding: '3px 6px' }}
                                                            onClick={() => {
                                                                setDescargoActivo(d);
                                                                setDescargoIdx(dIdx);
                                                                setShowDescargoModal(true);
                                                            }}
                                                        >
                                                            ⚡ {d.activo} {d.num_candado ? `(Candado: ${d.num_candado})` : '⚠️ Sin Candado'}
                                                        </span>
                                                    ))}
                                                </div>
                                            )}




                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </ExpandableCard>

                    {/* 4. Matriz de Riesgos y Medidas */}
                    <ExpandableCard onOpen={handleMarcarLeida}  title="Matriz de Riesgos y Medidas" icon="🚨">
                        {/*BUsca categorias unicas y pinta cada bloque*/}
                        {[...new Set(hpt.riesgos_detallados?.map(r => r.categoria))].map(cat => (
                            <div key={cat} className="mb-15">
                                <div className="res-cat-title">{cat}</div>
                                <div className="badge-grid">
                                    {/* Busca todos los riesgos que coincidan con la categoría que estamos pintando */}
                                    {hpt.riesgos_detallados.filter(r => r.categoria === cat).map(item => (
                                        // Pinta de rojo o de verde dependiendo de es_riesgo
                                        <div key={item.id_item} className={`item-badge ${item.es_riesgo ? 'badge-risk' : 'badge-measure'}`}>
                                            <strong>{item.codigo}</strong>: {item.descripcion}
                                            {item.observacion_riesgo && <span> ({item.observacion_riesgo})</span>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </ExpandableCard>
                    
                    {/* 5. Trabajadores (Subcontrata) */}
                    {/* SUBCONTRATAS MUTABLES: SE TRANSFORMA EN MODO EDICIÓN SÓLO SI EL USUARIO TIENE LA FIRMA PENDIENTE ACTUAL */}
                    <ExpandableCard onOpen={handleMarcarLeida} title="Personal Asignado y Habilitaciones" icon="👥">
                        {puedeFirmar() ? (
                            <div className="worker-grid">
                                {trabajadoresEditados.map((t, idx) => (
                                    <div key={idx} className="worker-card">
                                        <div className="worker-header">
                                            <strong>TRABAJADOR #{idx + 1}</strong>
                                            <button type="button" onClick={() => setTrabajadoresEditados(trabajadoresEditados.filter((_, i) => i !== idx))} className="del-btn">Eliminar</button>
                                        </div>
                                        <div className="row">
                                            <input className="main-input flex-1" placeholder="Nombre" value={t.nombre} onChange={e => updateTrabajadorEnDetalle(idx, 'nombre', e.target.value)} />
                                            <input className="main-input flex-1" placeholder="Apellidos" value={t.apellidos} onChange={e => updateTrabajadorEnDetalle(idx, 'apellidos', e.target.value)} />
                                        </div>
                                        <div className="row">
                                            <input className="main-input w-100" placeholder="Empresa Subcontrata..." value={t.empresa || ''} onChange={e => updateTrabajadorEnDetalle(idx, 'empresa', e.target.value)} />
                                        </div>
                                        <div className="hab-grid-full">
                                            {[
                                                {id: 'carretilla_elevadora', label: 'Carretilla Elev.'}, {id: 'carretilla_telescopica', label: 'C. Telescópica'},
                                                {id: 'plataforma_elevadora', label: 'Pla. Elevadora'}, {id: 'puente_grua', label: 'Puente Grúa'},
                                                {id: 'espacios_confinados', label: 'Esp. Confinados'}, {id: 'formacion_altura', label: 'F. Altura'},
                                                {id: 'baja_tension', label: 'Baja Tensión'}, {id: 'alta_tension', label: 'Alta Tensión'},
                                                {id: 'camion_pluma', label: 'Camión Pluma'}, {id: 'grua', label: 'Grúa'},
                                                {id: 'recurso_preventivo', label: 'RECURSO PREVENTIVO', special: true}
                                            ].map(hab => (
                                                <label key={hab.id} className={`hab-item ${t[hab.id] ? 'checked' : ''} ${hab.special ? 'special' : ''}`}>
                                                    <input type="checkbox" checked={t[hab.id]} onChange={e => updateTrabajadorEnDetalle(idx, hab.id, e.target.checked)} />
                                                    {hab.label}
                                                </label>
                                            ))}
                                            <input className="main-input span-2" placeholder="Otros certificados..." value={t.otros} onChange={e => updateTrabajadorEnDetalle(idx, 'otros', e.target.value)} />
                                        </div>
                                    </div>
                                ))}
                                <div className="worker-actions-container">
                                    <button 
                                        type="button" 
                                        onClick={addTrabajadorEnDetalle} 
                                        className="add-btn btn-worker-action"
                                    >
                                        ➕ Añadir Trabajador de Refuerzo
                                    </button>
                                    <button 
                                        type="button" 
                                        onClick={handleGuardarTrabajadores} 
                                        className="btn-save btn-worker-save"
                                    >
                                        💾 Guardar Cambios de Personal
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="worker-grid">
                                {hpt.trabajadores?.length > 0 ? (
                                    hpt.trabajadores.map((t, i) => (
                                        <div key={i} className="worker-card">
                                            <div className="worker-name">👤 {t.nombre} {t.apellidos}{t.empresa && <span className='worker-enterprise'>🏢 {t.empresa}</span>}</div>
                                            <div className="worker-skill-container">
                                                {[
                                                    { id: 'carretilla_elevadora', label: '🚜 Carretilla Elev.' }, { id: 'carretilla_telescopica', label: '🔭 C. Telescópica' },
                                                    { id: 'plataforma_elevadora', label: '🕹️ Pla. Elevadora' }, { id: 'puente_grua', label: '🏗️ Pte Grúa' },
                                                    { id: 'espacios_confinados', label: '🕳️ Confinados' }, { id: 'formacion_altura', label: '🧗 Altura' },
                                                    { id: 'baja_tension', label: '⚡ B.T.' }, { id: 'alta_tension', label: '🌩️ A.T.' },
                                                    { id: 'camion_pluma', label: '🚚 Camión Pluma' }, { id: 'grua', label: '🏗️ Grúa' },
                                                    { id: 'recurso_preventivo', label: '🛡️ R. Prev', isSpecial: true }
                                                ].map(hab => t[hab.id] ? <span key={hab.id} className={`skill-tag ${hab.isSpecial ? 'skill-preventive' : ''}`}>{hab.label}</span> : null)}
                                                {t.otros && t.otros.trim() !== '' && <span className="skill-tag" style={{ backgroundColor: '#eeeeee', color: '#424242' }}>📝 {t.otros}</span>}
                                            </div>
                                        </div>
                                    ))
                                ) : <p className="empty-text-msg">No hay trabajadores asignados.</p>}
                            </div>
                        )}
                    </ExpandableCard>
                </div>

                {/* === COLUMNA DERECHA: SEGUIMIENTO Y BOTONERA DE FIRMAS === */}
                <div className="right-column">
                    <div className="sticky-container">
                        
                        {/* Tracker Visual (La línea de tiempo con semáforos) */}
                        <SignatureTracker pasos={seguimiento} />
                        
                        {/* Botonera de Acción */}
                        <div className="action-buttons">
                            {/* Si la función Guardián dice que nos toca firmar, pintamos los botones activos */}
                            {puedeFirmar() && hpt.pendiente_de !== "COMPLETO" ? (
                                <>
                                    <button className={haLeidoTodo ? "btn-sign-now": "btn-sign-now_disable"} onClick={() => {
                                        if (!haLeidoTodo){
                                            Swal.fire({
                                                title: 'Lectura Obligatoria',
                                                text: `Debes desplegar y revisar todos los apartados de la planificación antes de poder firmar. Te faltan ${TOTAL_TARJETAS - tarjetasLeidas.length}.`,
                                                icon: 'warning',
                                                confirmButtonColor: '#003366'
                                            });
                                            return;
                                        }
                                        setShowSignature(true)
                                    }}>
                                        ✍️ FIRMAR COMO: {hpt.pendiente_de}
                                    </button>
                                    
                                    {/* El Solicitante (creador) no puede rechazar su propia HPT, el resto sí */}
                                    {hpt.pendiente_de !== "SOLICITANTE" && (
                                        <button className="btn-reject-now" onClick={handleRechazar}>
                                            ❌ RECHAZAR PLAN
                                        </button>
                                    )}
                                </>
                            ) : (
                                // Si no nos toca, o si ya se ha cerrado, pinto un recuadro de aviso gris
                                <div className="wait-box">
                                    {hpt.pendiente_de === "COMPLETO" 
                                        ? "✅ PROCESO DE FIRMAS FINALIZADO" 
                                        : `⏳ ESPERANDO A: ${hpt.pendiente_de}`}
                                </div>
                            )}
                        </div>
                        {hpt.pendiente_de === 'JEFE_TURNO' && puedeFirmar() && (
                            <div className="jt-comment-box">
                                <label>📝 Observaciones del Jefe de Turno:</label>
                                <textarea 
                                    value={comentarioJT}
                                    onChange={(e) => setComentarioJT(e.target.value)}
                                    placeholder="Escribe aqui los comentarios..."
                                    rows="4"
                                />
                                <button className="btn-save-comment" onClick={handleGuardarComentarioJT}>
                                    💾 Guardar Comentario
                                </button>
                            </div>
                        )}
                        {(!puedeFirmar() || hpt.pendiente_de !== 'JEFE_TURNO') && hpt.comentarios_jt && (
                            <div className="jt-comment-display">
                                <strong>📝 Notas del Jefe de Turno:</strong>
                                <p>{hpt.comentarios_jt}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* PAD DE FIRMA FLOTANTE */}
            {showSignature && <SignaturePad onSave={handleSign} onCancel={() => setShowSignature(false)} />}
            
            {/* MODAL DE PERMISO DE ESCALERA */}
            {showEscaleraModal && (
                <PermisoEscalera 
                    datosPrevios={datosEscaleraEditados} 
                    usuarioActual={currentUser.user}
                    // Si tiene permiso de edición, la funcion se activa, sino, oncultamos el boton
                    onSave={(nuevosDatos) => {
                        if (puedeEditarEscalera()) {
                            handleActualizarEscalera(nuevosDatos);
                        } else {
                            Swal.fire('Solo Lectura', 'No tienes permisos para modificar el anexo en esta etapa del proceso.', 'info');
                        }
                    }}
                    onCancel={() => setShowEscaleraModal(false)}
                    // Le pasamos un prop "readOnly" al componente para que desactive los inputs si no se puede editar
                    readOnly={!puedeEditarEscalera()} 
                />
                
            )}

            {/* COMPONENTE FLOTANTE: HOJA DE ENCLAVAMIENTO */}
            {showBloqueoModal && bloqueoActivo && (
                <BloqueoElectrico 
                    bloqueo={bloqueoActivo}
                    hpt={hpt}
                    onSave={handleGuardarCandadoBloqueo}
                    onCancel={() => setShowBloqueoModal(false)}
                />
            )}

            {/* COMPONENTE FLOTANTE: HOJA DE DESCARGO */}
            {showDescargoModal && descargoActivo && (
                <DescargoElectrico 
                    descargo={descargoActivo}
                    hpt={hpt}
                    onSave={handleGuardarCandadoDescargo}
                    onCancel={() => setShowDescargoModal(false)}
                />
            )}
        </div>
    );
};

export default DetailsHPTScreen;